import React from 'react';
import { Switch, RouteProps, useRouteMatch, Route } from 'react-router-dom';

import Reports from '@screens/Reports';

const SettingsRoutes: React.FC<RouteProps> = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/`} component={Reports} />
    </Switch>
  );
};

export default SettingsRoutes;
